/*
 * @Author: chengunghua
 * @Date: 2022-05-05 16:58:32
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-07 14:30:07
 * @Description: file content
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const wbqdManageService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/common/getQdlb`, { params: params }); },

  // 查看
  getDetail: (id) => { return axios.get(`${iffApi}/wbqd/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/wbqd/export`, { responseType: 'blob', params }); }
};
